import styled from 'styled-components';

export const KimLhcTableContainerFirstRow = styled.div<{ $womanColor: string; $manColor: string }>`
	.ant-table {
		min-width: 20rem;
		border-radius: 0.625rem;
		border: 1px solid #e6e8e8;

		.ant-table-cell {
			border-left: 1px solid #e6e8e8;
			padding-top: 0.4rem !important;
			padding-bottom: 0.4rem !important;
		}

		.ant-table-wrapper {
			display: flex;
			justify-content: center;
			.ant-spin-nested-loading {
				width: 25rem;
			}
		}

		.ant-table-thead {
			th {
				font-weight: bold;
				text-align: center;
				background-color: #e6e8e8;
				padding-top: 0.4rem !important;
				padding-bottom: 0.4rem !important;
			}

			tr:last-child {
				> th:not(:last-child)::before {
					display: none;
				}
				.ant-table-cell:first-child {
					border-radius: 0.625rem 0 0 0;
				}
				.ant-table-cell:last-child {
					border-radius: 0 0.625rem 0 0;
				}
			}
		}

		.ant-table-tbody {
			tr:last-child {
				.ant-table-cell {
					color: #fff;
					font-size: 0.875rem;
					font-weight: 600;
					text-align: center;
					border-bottom: none;
				}
				.ant-table-cell:first-child {
					border-right: 1px solid #fff;
					border-radius: 0 0 0 0.625rem;
					background-color: ${({ $womanColor }) => $womanColor};
				}
				.ant-table-cell:last-child {
					border-radius: 0 0 0.625rem 0;
					background-color: ${({ $manColor }) => $manColor};
				}
			}
		}
	}
`;

export const KimLhcGenderRowContainer = styled.div<{ $riskColor: string }>`
	.ant-table {
		min-width: 20rem;
		border-radius: 0.625rem;
		border: 1px solid #e6e8e8;

		.ant-table-cell {
			border-left: 1px solid #e6e8e8;
			padding-top: 0.4rem !important;
			padding-bottom: 0.4rem !important;
			font-size: 0.875rem;
		}

		.ant-table-wrapper {
			display: flex;
			justify-content: center;
			.ant-spin-nested-loading {
				width: 25rem;
			}
		}

		.ant-table-thead {
			th {
				font-weight: bold;
				text-align: center;
				background-color: #e6e8e8;
				padding-top: 0.4rem !important;
				padding-bottom: 0.4rem !important;
			}

			tr:last-child {
				.ant-table-cell:first-child {
					border-radius: 0.625rem 0 0 0;
				}
				.ant-table-cell:last-child {
					border-radius: 0 0.625rem 0 0;
				}
			}
		}

		.ant-table-tbody {
			tr:last-child {
				.ant-table-cell {
					border-bottom: none;
				}
				.ant-table-cell:first-child {
					color: #fff;
					font-size: 0.875rem;
					font-weight: 600;
					text-align: center;
					border-radius: 0 0 0 0.625rem;
					background-color: ${({ $riskColor }) => $riskColor};
				}
			}
		}
	}
`;

export const KimLhcTableContainerSecondRow = styled.div`
	.ant-table {
		min-width: 20rem;
		border-radius: 0.625rem;
		border: 1px solid #e6e8e8;

		.ant-table-cell {
			border-left: 1px solid #e6e8e8;
			padding-top: 0.4rem !important;
			padding-bottom: 0.4rem !important;
			font-size: 0.875rem;
		}

		.ant-table-wrapper {
			display: flex;
			justify-content: center;
			.ant-spin-nested-loading {
				width: 25rem;
			}
		}

		.ant-table-thead {
			th {
				font-weight: bold;
				text-align: center;
				background-color: #e6e8e8;
				padding-top: 0.4rem !important;
				padding-bottom: 0.4rem !important;
			}

			tr:last-child {
				.ant-table-cell:first-child {
					border-radius: 0.625rem 0 0 0;
				}
				.ant-table-cell:last-child {
					border-radius: 0 0.625rem 0 0;
				}
			}
		}

		.ant-table-tbody {
			tr:last-child {
				.ant-table-cell {
					border-bottom: none;
				}
				.ant-table-cell:first-child {
					border-radius: 0 0 0 0.625rem;
				}
				.ant-table-cell:last-child {
					border-radius: 0 0 0.625rem 0;
				}
			}
		}
	}
`;
